<template>
  <v-app id="app_overall_tracking_history">
    <v-overlay v-model="loadningScreen" class="centered-overlay">
      <v-progress-circular
        color="green"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">TOTAL DISTANCE HISTORY</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Analyse the collection of total distance history data based on
            officers.
          </p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider
              :thickness="3"
              class="divider-vertical"
              vertical
            ></v-divider>
            <v-btn
              class="gray-text"
              size="x-large"
              variant="text"
              @click="backPageRoute()"
            >
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card
        class="custom_card_box mt-8"
        elevation="1"
        border="sm opacity-1"
        rounded="lg"
      >
        <template v-slot:append>
          <v-card-text class="custom_tool_bar_style">
            <v-btn class=" custom_pdf_btn " variant="outlined" @click="total_distance_sync_dialog = true">
            <v-icon size="large">mdi-sync</v-icon>&nbsp;&nbsp;Sync Total Distance
          </v-btn>
            <v-btn
              class="custom_pdf_btn"
              variant="outlined"
              @click="isClickedDownloadPDFBtn"
            >
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>

            <v-btn
              class="custom_excel_btn ml-4"
              variant="outlined"
              @click="isClickedDownloadExcelBtn"
            >
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-card-text>
        </template>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" md="4">
              <v-date-input
                v-model="dates"
                append-inner-icon="mdi-close"
                prepend-inner-icon="$calendar"
                prepend-icon=""
                label="Select Date Range"
                multiple="range"
                variant="outlined"
                @click:append-inner="clearDateRange"
                density="comfortable"
                class="custom_input_field_color"
              ></v-date-input>
            </v-col>

             <v-col cols="12" md="4">
              <v-autocomplete
              v-model="agentList"
              :items="agentOptions"
              clearable
              label="Officer"
              placeholder="Select officer"
              variant="outlined"
              item-title="name"
              item-value="id"
              density="comfortable"
              class="custom_input_field_color"
              multiple
            >
              <template v-slot:item="{ props, item }">
                <v-list-item
                  v-bind="props"
                  :title="item.raw.name"
                  :subtitle="item.raw.registration_num"
                ></v-list-item>
              </template>
            </v-autocomplete>

             </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="serachModel"
                label="Search"
                persistent-placeholder
                placeholder="Search"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>

             <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedPremiseCode"
              :items="premiseCodeList"
              clearable
              item-title="role_type"
              item-value="id"
              label="Premise Code"
              placeholder="Select Premise Code"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedDivisionCode"
              :items="divisionCodeList"
              clearable
              item-title="name"
              item-value="id"
              label="Division Code"
              placeholder="Select Division Code"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedStatus"
              :items="statusList"
              clearable
              item-title="name"
              item-value="id"
              label="Status"
              placeholder="Select Status"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>
        </v-row>

        <v-row
          class="pa-2 ma-3"
          style="
            background-color: #fff3cd;
            border: 1px solid #566573;
            border-radius: 4px;
          "
        >
          <v-col class="d-flex align-center" cols="12">
            <v-icon color="success" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span class="mr-4" style="font-size: 12px; color: #333"
              >APPROVED</span
            >

            <v-icon color="#efac00" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span class="mr-4" style="font-size: 12px; color: #333">PENDING</span>

            <v-icon color="error" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span style="font-size: 12px; color: #333">REJECTED</span>
          </v-col>
        </v-row>


          <v-divider></v-divider>

          <v-data-table
            :headers="headers"
            :items="filteredData"
            :loading="loading"
            :search="serachModel"
            class="custom_table_normal"
          >
            <template v-slot:[`item.user.name`]="{ item }">
              
              <p
                class="text-caption custom_page_main_sub_title font-weight-bold mt-2"
              >
               <v-icon v-if="item.status == 1" color="success" size="small" class="mr-1">
                mdi-checkbox-blank-circle
                </v-icon>
                <v-icon v-else-if="item.status == 0" color="#efac00" size="small" class="mr-1">
                mdi-checkbox-blank-circle
                </v-icon>
                <v-icon v-else-if="item.status == -1" color="error" size="small" class="mr-1">
                mdi-checkbox-blank-circle
                </v-icon>
                {{ item.user.name }}

              </p>
              <v-divider class="mt-2 mb-2"></v-divider>
              <p
                class="custom_page_main_sub_title_very_small_red text-caption font-weight-medium mb-2"
              >
                {{ item.RegisterNumber }}
              </p>
            </template>

            <template v-slot:[`item.fistAddress`]="{ item }">
              <p
                class="text-caption custom_page_main_sub_title font-weight-bold mt-2"
              >
                {{ item.fistAddress }}
              </p>
              <v-divider class="mt-2 mb-2"></v-divider>
              <!-- <p class="custom_font_color_view text-caption font-weight-medium mb-2">{{ item.statTime }}</p> -->
              <p
                class="custom_font_color_view text-caption font-weight-medium mb-2"
              >
                {{ item.statTime }}
              </p>
            </template>

            <template v-slot:[`item.lastAddress`]="{ item }">
              <p
                class="text-caption custom_page_main_sub_title font-weight-bold mt-2"
              >
                {{ item.lastAddress }}
              </p>
              <v-divider class="mt-2 mb-2"></v-divider>
              <!-- <p class="custom_font_color_view text-caption font-weight-medium mb-2">{{ item.endTime }}</p> -->
              <p
                class="custom_font_color_view text-caption font-weight-medium mb-2"
              >
                {{ item.endTime }}
              </p>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_user_role_list">
                <template v-slot:activator="{ props }">
                  <v-btn
                    class="custom_btn_primary"
                    variant="flat"
                    size="large"
                    v-bind="props"
                  >
                    ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="permissions.read" @click="mapView(item)">
                    <v-list-item-title class="custom_font_color_view"
                      >VIEW</v-list-item-title
                    >
                  </v-list-item>
                  <!-- <v-list-item
                    v-if="permissions.delete"
                    @click="confirmDelete(item)"
                  >
                    <v-list-item-title class="custom_font_color_delete"
                      >DELETE</v-list-item-title
                    >
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </template>

            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                  v-model="page"
                  :length="totalPages"
                  :total-visible="10"
                ></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!--  collection recode edit view component call to dialog box-->
      <v-dialog
        v-model="mapViewDialog"
        fullscreen
        id="app_overall_tracking_history"
      >
        <v-card flat>
          <v-toolbar
            style="border-radius: 0px !important"
            class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box"
            color="white"
            dense
          >
            <v-toolbar-title>
              <v-img
                class="custom_company_logo_nav"
                :src="require('@/img/company_logo/Assetline_logo.png')"
                @click="closeD()"
              ></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="custom_red_btn"
              variant="flat"
              @click="mapViewDialog = false"
            >
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card
                class="pa-0 mx-6 mt-2 custom_card_box"
                border="sm opacity-1"
              >
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title
                    class="font-weight-bold custom_page_main_sub_title ml-3"
                    >MAP VIEW</v-card-title
                  >
                </template>
              </v-card>

              <v-card
                ref="mapElement"
                class="pa-3 mx-6 custom_card_box mt-4"
                border="sm opacity-1"
              >
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="4" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
                        <!--                        <v-img :src="OfficerDetails.user_image ? `${baseUrl}/SFA/public/${user.OfficerDetails.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')"-->
                        <!--                               max-width="150" class="user_image_view"></v-img>-->

                        <v-img
                          :src="
                            this.agentImage
                              ? `${baseUrl}/${this.agentImage}`
                              : require('@/assets/ASSETS/PERSONS/person-3.jpg')
                          "
                          max-width="150"
                          class="avatar-image"
                        />
                      </v-col>
                      <v-col cols="5" xs="5" sm="5" md="5" lg="5" xl="5">
                        <v-table density="compact" class="custom_table_normal">
                          <tbody>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-body-2"
                                >
                                  Officer Name &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-body-2"
                                  style="color: #01579B !important"
                                >
                                  {{ this.agentName }}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Visited Date &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                  style="color: #01579B !important"
                                >
                                  {{ this.visitedDate }}
                                </p>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Start Location &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                  style="color: #01579B !important"
                                >
                                  {{ this.startLocation }}
                                </p>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  End Location &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                  style="color: #01579B !important"
                                >
                                  {{ this.endLocation }}
                                </p>
                              </td>
                            </tr>
                            

                          </tbody>
                        </v-table>
                      </v-col>

                      <v-col cols="5" xs="5" sm="5" md="5" lg="5" xl="5">

                        <v-table density="compact" class="custom_table_normal mt-2" style="background-color:#e5ae126b;">
                          <tbody>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-body-2"
                                  style="color: #01579B !important"
                                >
                                 <strong> Total Distance &nbsp; </strong>
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-body-2"
                                  style="color: #01579B !important"
                                >
                                 <strong>  {{ this.totalDistance +" " }} Km </strong>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Official Route Distance &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                >
                                  {{ this.officialDistance +" " }} Km
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Personal Route Distance &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                >
                                  {{ this.personalDistance +" " }} Km
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Personal Route Distance (Manual Entry) &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                >
                                  {{ this.personalDistanceManualEntry +" " }} Km
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Official Route Distance (Derived) &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                >
                                  {{ (officialDistanceManualEntry) + ' Km' }}
                                </p>
                              </td>
                            </tr>
                            
                          </tbody>
                        </v-table>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="3" md="3" lg="3" v-if="permissions.write">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                      <v-btn
                      class="ml-2"
                        size="large"
                        variant="outlined"
                        v-if="showDownloadButton"
                        @click="openApprovalDialogWindow"
                        >Action</v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

               
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <!--  collection recode edit view component call to dialog box-->

      <!-- Dialog Box for Approval Route -->

      <v-dialog
          v-model="routeApprovalDialog"
          max-height="700"
          id="app_lead_list"
          max-width="900"
        >
          <v-card rounded="md">
            <div class="pa-4">
              <v-card color="#F0F0F0" flat>
                <template v-slot:prepend>
                  <v-card-title class="text-subtitle-1 font-weight-bold">
                    APPROVE REQUEST
                  </v-card-title>
                </template>
                <v-spacer></v-spacer>
                <template v-slot:append>
                  <v-btn
                    @click="routeApprovalDialog = false"
                    icon="mdi-close"
                    size="x-small"
                  ></v-btn>
                </template>
              </v-card>

              <!-- Form Content -->
              <v-card-text>
                <v-form ref="form">
                        <v-radio-group v-model="selectedCatagoryOption" inline>
                          <v-radio :label="'Official Route Distance - (' + officialDistance +')'" value="officialDistance" style="width: 50%;"></v-radio>
                          <v-radio :label="'Official Route Distance (Derived) - (' + officialDistanceManualEntry + ' km)'" value="officialDistanceManually" style="width: 50%;"></v-radio>
                        </v-radio-group>
                  <v-textarea
                    v-model="remarkOfApproval"
                    label="Message"
                    placeholder="Enter your message"
                  ></v-textarea>
                </v-form>
              </v-card-text>

              <!-- Action Buttons -->
              <v-card-actions class="d-flex justify-end">
                <v-btn
                :disabled="!isFormFilled"
                  style="
                    width: 30% !important;
                    background-color: #e6effc !important;
                    border: 1px solid #0000ff !important;
                    color: #0000ff !important;
                  "
                  variant="outlined"
                  @click="approveRequest('APPROVED')"
                >
                  APPROVE
                </v-btn>
                <v-btn
                :disabled="!isFormFilled"
                  style="
                    width: 30% !important;
                    background-color: #fdecea !important;
                    border: 1px solid #f44336 !important;
                    color: #f44336 !important;
                  "
                  variant="outlined"
                  @click="approveRequest('REJECTED')"
                >
                  REJECT
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>

        <v-dialog
        v-model="rejectApprovedDialog"
        max-height="700"
        id="app_lead_list"
        max-width="600"
      >
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                  REJECT REQUEST
                </v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn
                  @click="rejectApprovedDialog = false"
                  icon="mdi-close"
                  size="x-small"
                ></v-btn>
              </template>
            </v-card>

            <!-- Form Content -->
            <v-card-text>
              <v-form ref="form">
                <v-textarea autocomplete="Message" label="Message" v-model="rejectReason" :counter="maxChars"
                            :maxlength="maxChars"></v-textarea>
              </v-form>
            </v-card-text>

            <!-- Action Buttons -->
            <v-card-actions class="d-flex justify-end">
              <v-btn
                style="
                  width: 30% !important;
                  background-color: #fdecea !important;
                  border: 1px solid #f44336 !important;
                  color: #f44336 !important;
                "
                variant="outlined"
                @click="rejectRequest"
              >
                REJECT
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>


      <!-- Delete User confirmation dialog -->
      <v-dialog
        v-model="deleteDialog"
        id="app_overall_tracking_history"
        max-height="500"
        max-width="500"
        persistent
      >
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold"
                  >DELETE TRACKING DATA</v-card-title
                >
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn
                  @click="deleteDialog = false"
                  icon="mdi-close"
                  size="x-small"
                ></v-btn>
              </template>
            </v-card>


            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title
                  style="color: #bb0000"
                  class="text-body-1 font-weight-medium"
                >
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this tracking record ?
                </v-card-title>

                <p style="opacity: 0.7" class="text-body-2 mt-4 text-justify">
                  This tracking record will be deleted immediately. Once
                  deleted, it can no longer be used for any purpose.
                  
                </p>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4">
                  <v-btn
                    style="
                      width: 35% !important;
                      background-color: #fdecea !important;
                      border: 1px solid #f44336 !important;
                      color: #f44336 !important;
                    "
                    variant="outlined"
                    @click="deleteItem"
                    :loading="deleteLoading"
                  >
                    DELETE
                  </v-btn>
                  <v-btn
                    class="ml-3 custom_btn_secondary"
                    @click="deleteDialog = false"
                    >CANCEL</v-btn
                  >
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

       <!-- Sync Total Distance confirmation dialog -->
      <v-dialog v-model="total_distance_sync_dialog" id="app_user_list" max-height="500" max-width="500" persistent>
        <v-card id="app_user_list" rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                  Total Distance Synchronization
                </v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="total_distance_sync_dialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #05146F" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Are you sure you want to Sync total distance?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This feature allows you to synchronize officer total distance data.
                </p>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4">
                  <v-btn class="custom_btn_primary" @click="startToSyncTotalDistance">
                    Start to Sync
                  </v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="total_distance_sync_dialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>


      <v-snackbar
        v-model="snackAlert.snackbar"
        :color="snackAlert.snackColor"
        :right="snackAlert.snackBarRight"
        :top="snackAlert.snackBarTop"
        timeout="3000"
      >
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>
<script>
import index from "vuex";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { getPermissions } from "@/plugins/permissions";

export default {
  data() {
    return {
      total_distance_sync_dialog:false,
      agentOptions: [],
      agentTypeList: [], // For officer type filter
      agentTypeOptions: [], // Will store officer type options
      page: 0,
      totalPages: 0,
      loading: false,
      loadningScreen: false,
      startLocation: "",
      endLocation: "",
      deleteAgentId: "",
      showDownloadButton: true,
      deleteDate: "",
      startTime: "",
      snackAlert: {
        snackbar: false, // Snackbar visibility
        snackColor: "", // Snackbar color
        snackMessage: "", // Snackbar message
        snackBarRight: false, // Snackbar position right
        snackBarTop: true, // Snackbar position top
      },
       divisionCodeList:[],
      selectedDivisionCode:null,
      premiseCodeList:[],
      selectedPremiseCode:null,
      statusList:['ALL','APPROVED','PENDING','REJECTED'],
      selectedStatus:null,
      endTime: "",
      agentImage: "",
      visitedDate: "",
      agentName: "",
      RouteSwitchJustifications:[],
      personalDistanceManualEntry:"",
      agentDataOptions: [],
      dates: [],
      serachModel: "",
      firstOutlet: "",
      secondOutlet: "",
      baseUrl: "",
      search: " ",
      deleteDialog: false,
      itemToDelete: null,
      deletedDate: "",
      deletedType: "",
      routeId: "",
      mapViewDialog: false,
      isDownloadedExcel: false,
      isDownloadedPDF: false,

      routeApprovalDialog:false,
      rejectApprovedDialog:false,
      remarkOfApproval:"",
      selectedAgentID:"",
      selectedCatagoryOption:null,

      headers: [
        { text: "OFFICER NAME", value: "user.name", title: "OFFICER NAME" },
        {
          text: "START LOCATION",
          value: "start_address",
          title: "START LOCATION",
        },
        { text: "END LOCATION", value: "end_address", title: "END LOCATION" },
        {
          text: "TOTAL DISTANCE",
          value: "total_distance",
          title: "TOTAL DISTANCE(Km)",
        },
        {
          text: "OFFICER CATEGORY",
          value: "user.user_catagory.role_type",
          title: "OFFICER CATEGORY",
        },
        { text: "DATE", value: "date", title: "DATE" },
        { text: "Action", value: "actions", sortable: false, title: "ACTION" },
      ],
      trackingData: [],
      totalDistance: "",
      trackingHistary: [],
      OfficerDetails: {
        user_image: null,
      },
      center: { lat: 7.375783804167988, lng: 80.63752981355924 },
      pathCoordinates: [{ lat: "", lng: "" }],
      polylineOptions: {
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 3,
      },
      startPoint: "",
      endPoint: "",
      startIcon: {
        url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
      },
      endIcon: {
        url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
      },
      agentList: [],
      agents: [
        {
          location: "Mawaramandiya",
          lastUpdated: "30 seconds ago",
          locAddress: "bla blaa blaaaaa",
          locationType: "startLocation",
          trips: [
            { id: 1, destination: "Keells - Edmonton", time: "09:16 AM" },
            { id: 2, destination: "Keells - Kohuwala", time: "10:30 AM" },
          ],
        },
      ],
      mapCenter: { lat: 6.023129913557325, lng: 80.79783798218944 },
      permissions: {},
    };
  },

  watch: {
    agentList: {
      handler() {
        this.getAllTotalDistanceTracking(this.page);
      },
    },

    dates: {
      handler() {
        this.getAllTotalDistanceTracking(this.page);
      },
    },

    serachModel: {
      handler() {
        this.getAllTotalDistanceTracking(this.page);
      },
    },

     selectedPremiseCode: {
      handler() {
        this.getAllTotalDistanceTracking(this.page);
      },
    },

    selectedDivisionCode: {
      handler() {
        this.getAllTotalDistanceTracking(this.page);
      },
    },
 
    selectedStatus: {
      handler() {
        this.getAllTotalDistanceTracking(this.page);
      },
    },

    page(newVal, oldVal) {
      // if (newVal <= 0) {
      //   this.page = 1;
      //   return;
      // }
      console.log("Current page click", newVal, oldVal);
      this.getAllTotalDistanceTracking(newVal);
    },
  },

  computed: {
    index() {
      return index;
    },

    isFormFilled() {
    return this.selectedCatagoryOption && this.remarkOfApproval.trim() !== '';
    },

    totalDistanceInKm() {
      if (!this.totalDistance) return 0;

      const match = this.totalDistance.match(/^([\d.]+)\s*(km|m)$/i);
      if (!match) return 0;

      const value = parseFloat(match[1]);
      const unit = match[2].toLowerCase();

      return unit === 'm' ? value / 1000 : value;
    },

    officialRouteDistanceManually() {
      const personalKm = parseFloat(this.personalDistanceManualEntry) || 0;
      return (this.totalDistanceInKm - personalKm).toFixed(2); // 2 decimal places
    },

     agentOptionsFromTable() {
    const uniqueAgents = new Map();
    this.trackingData.forEach(item => {
      if (item.agentName && !uniqueAgents.has(item.agentName)) {
        uniqueAgents.set(item.agentName, {
          name: item.agentName,
          regNum: item.RegisterNumber
        });
      }
    });
    return Array.from(uniqueAgents.values());
  },

    filteredData() {
      let filtered = this.trackingData;

      // Apply filters (same as before)
      filtered = filtered.filter(
        (item) =>
          item.user.name
            .toLowerCase()
            .includes(this.serachModel.toLowerCase()) ||
            item.user.email
            .toLowerCase()
            .includes(this.serachModel.toLowerCase()) ||
          item.total_distance.toLowerCase().includes(
            this.serachModel.toLowerCase()
          ) ||
          item.date.toLowerCase().includes(this.serachModel.toLowerCase()) ||
          item.personal_distance
            .toLowerCase()
            .includes(this.serachModel.toLowerCase()) ||
          item.official_distance
            .toLowerCase()
            .includes(this.serachModel.toLowerCase())
      );

      // Filter by selected agents
      if (Array.isArray(this.agentList) && this.agentList.length > 0) {
        filtered = filtered.filter((item) =>
          this.agentList.includes(item.agent_id)
        );
      }

      // Filter by selected date range
      // const formatDate = (date) => new Date(date).toISOString().split("T")[0];
      // const startDate = this.dates.length ? formatDate(this.dates[0]) : null;
      // const endDate = this.dates.length
      //   ? formatDate(this.dates[this.dates.length - 1])
      //   : null;

      // if (startDate && endDate) {
      //   filtered = filtered.filter(
      //     (item) => item.date >= startDate && item.date <= endDate
      //   );
      // }

      // Calculate totalDistance per row
      filtered = filtered.map((item) => {
        let distance = 0;
        const details = item.OverRollTrackingDetails || [];

        for (let i = 0; i < details.length - 1; i++) {
          const point1 = details[i];
          const point2 = details[i + 1];
          distance += this.calculateDistance(
            point1.lat,
            point1.lng,
            point2.lat,
            point2.lng
          );
        }

        let distanceFormatted = "";
        if (distance >= 1) {
          distanceFormatted = `${Math.round(distance)}KM`; // round KM
        } else {
          distanceFormatted = `${Math.round(distance * 1000)}M`; // meters
        }

        return {
          ...item,
          totalDistance: distanceFormatted,
        };
      });

      return filtered;
    },
  },

  mounted() {

    const dashboardId = 7;
    this.permissions = getPermissions(dashboardId);

    this.getAllTotalDistanceTracking(this.page);
    this.fetchAllAgents();
    this.getBaseUrl();
  },

  methods: {
    backPageRoute() {
      // this.$router.push('/dashboard');
      this.$router.go(-1);
    },

    getBaseUrl() {
      this.baseUrl = `${process.env.VUE_APP_IMAGE_PUBLIC_URL}`;
    },

    openApprovalDialogWindow(){
      this.routeApprovalDialog = true;
    },

    approveRequest(status){
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      const valueOfManualOfficialDistance = this.officialRouteDistanceManually;

      this.loadningScreen = true;

      axios.post(`api/overRollTrackingApprovalRequest`, {
        userId: this.selectedAgentID,
        proceedBy: userId,
        startTime: this.startTime,
        endTime: this.endTime,
        date: this.visitedDate,
        remark: this.remarkOfApproval,
        officialDistance: this.officialDistance,
        officialDistanceManually: valueOfManualOfficialDistance + ' km',
        radioBtnValue: this.selectedCatagoryOption,
        status: status,

      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => {

        if (response.data.success) {
        this.loadningScreen = false;
        this.routeApprovalDialog = false;
        this.mapViewDialog = false;

        this.remarkOfApproval = "";

        if(status == "APPROVED"){
          this.showSnackbar("Request was approved successfully!", "success");
        }
        if(status == "REJECTED"){
          this.showSnackbar("Request was rejected successfully!", "success");
        }

        

        this.getAllTotalDistanceTracking(this.page);
        }

        // console.log("JSON",response.data);
      if(response.data.type == 'insert'){
        if (response.data.success_erp) {
          this.showSnackbar("ERP Updated successfully!", "success");
        }else{
          const parsedResponse = JSON.parse(response.data.message_erp.response)
          this.showSnackbar("ERP Error - "+parsedResponse.data, "error");
        }
      }

      })
      .catch(error => {
        console.error('Error fetching data:', error);
        this.loadningScreen = false;
      });
    },

    calculateDistance(lat1, lon1, lat2, lon2) {
      const toRad = (value) => (value * Math.PI) / 180;
      const R = 6371; // Radius of Earth in km

      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
          Math.cos(toRad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c; // Distance in km
    },

    downloadPdf() {
      this.showDownloadButton = false;
      this.$nextTick(() => {
        const mapElement = this.$refs.mapElement?.$el || this.$refs.mapElement;
        if (mapElement instanceof HTMLElement) {
          html2canvas(mapElement, {
            useCORS: true,
            logging: true,
            scale: 2,
          })
            .then((canvas) => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF({
                orientation: "landscape",
                unit: "pt",
                format: [canvas.width, canvas.height],
              });

              // Add the captured image to the PDF
              pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);

              // Save the PDF
              pdf.save("overall History.pdf");

              this.showDownloadButton = true;
            })
            .catch((error) => {
              console.error("Error capturing the map:", error);
              this.showDownloadButton = true;
            });
        } else {
          console.error("Map element is not attached or is not a valid node.");
          this.showDownloadButton = true;
        }
      });
    },

    clearDateRange() {
      this.dates = [];
    },

    exportPDF() {
    const doc = new jsPDF();

    // Set title
    doc.text("Total Distance Report", 14, 10);

    // Prepare table data
    const tableData = this.filteredData.map((item, index) => [
        index + 1,
        item.user?.name || '-',                           
        item.user?.registration_num || '-',                  
        item.user?.prem_code || '-',
        item.user?.user_catagory?.role_type || '-',
        item.start_address || '-',
        item.end_address || '-',
        item.total_distance || '0.000',
        item.date || '-',
        item.status === 1
                        ? 'Approved'
                        : item.status === 0
                        ? 'Pending'
                        : item.status === -1
                        ? 'Rejected'
                        : '-'
    ]);

    // Define column headers
    const tableColumns = [
        "#",
        "OFFICER NAME",
        "OFFICER NUMBER",
        "PREMISE CODE",
        "ROLE TYPE",
        "START LOCATION",
        "END LOCATION",
        "TOTAL DISTANCE",
        "DATE",
        "STATUS"
    ];

    // Generate PDF table
    doc.autoTable({
        head: [tableColumns],
        body: tableData,
        startY: 20,
        styles: {
        fontSize: 8,
        },
        headStyles: {
        fillColor: [41, 128, 185],
        },
    });

    this.isDownloadedPDF = false;

    // Save the file
    doc.save("Total_Distance_History.pdf");
    },


    exportExcel() {
        const tableData = this.filteredData.map((item) => ({
            "OFFICER NAME": item.user?.name || "-",
            "OFFICER NUMBER": item.user?.registration_num || "-",
            "PREMISE CODE": item.user?.prem_code || "-",
            "ROLE TYPE": item.user?.user_catagory?.role_type || "-",
            "START LOCATION": item.start_address || "-",
            "END LOCATION": item.end_address || "-",
            "TOTAL DISTANCE": item.total_distance || "0.000",
            "DATE": item.date || "-",
            "STATUS": item.status === 1
                        ? 'Approved'
                        : item.status === 0
                        ? 'Pending'
                        : item.status === -1
                        ? 'Rejected'
                        : '-'
        }));

        const worksheet = XLSX.utils.json_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Tracking");

        this.isDownloadedExcel = false;
        XLSX.writeFile(workbook, "Total_Distance_History.xlsx");
    },


    isClickedDownloadExcelBtn() {
      this.isDownloadedExcel = true;
      this.getAllTotalDistanceTracking(this.page);
    },

    isClickedDownloadPDFBtn() {
      this.isDownloadedPDF = true;
      this.getAllTotalDistanceTracking(this.page);
    },

    // Get All Tracing Historay
     getAllTotalDistanceTracking(page) {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('token');

    this.loading = true;

    axios.post(`api/tracking/total-distance?page=${page}`, {
      userId: userId,
      agentList: this.agentList,
      agentTypeList: this.agentTypeList,
      dates: this.dates,
      search: this.serachModel,
      selectedPremiseCode: this.selectedPremiseCode,
      selectedDivisionCode: this.selectedDivisionCode,
      selectedStatus: this.selectedStatus,
      is_downloaded: this.isDownloadedExcel,
      is_downloaded_pdf: this.isDownloadedPDF,
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      this.trackingData = response.data.data;
      this.agentOptions = response.data.officerList;
      this.divisionCodeList = response.data.divisionCode;
      this.premiseCodeList = response.data.premiseCode;
      this.totalPages = response.data.pagination?.last_page || 1;
      this.page = response.data.pagination?.current_page || 1;
      this.loading = false;

      // Update agent options whenever new data is fetched
      // this.agentOptions = this.agentOptionsFromTable;

      if (this.isDownloadedExcel) {
        this.exportExcel();
        this.submitPdfExcelLog("pdf");
      }

      if (this.isDownloadedPDF) {
        this.exportPDF();
        this.submitPdfExcelLog("Excel");
      }

      this.isDownloadedExcel = false;
      this.isDownloadedPDF = false;
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      this.loading = false;
      this.isDownloadedExcel = false;
      this.isDownloadedPDF = false;
    });
  },


    submitPdfExcelLog(Type){

       const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      const type = Type;

        axios.post(
        `${process.env.VUE_APP_API_BASE_URL}api/submit-pdfand-excel-log`,
        { userId: userId, type: type },
        { 
            headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
            }
        }
        )
    },

    //   Sync Total Distance
    startToSyncTotalDistance(){
    
         this.loadningScreen = true;
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');

        axios.post(
        `${process.env.VUE_APP_API_BASE_URL}api/tracking/total-distance/calculate`,
        { userID: userId,force_sync: true },
        { 
            headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
            }
        }
        )
        .then(response => {
        if (response.data.http_status === 'success' || response.data.http_status === 'ok') {
            this.loadningScreen = false;
            this.total_distance_sync_dialog = false;
           this.getAllTotalDistanceTracking(this.page);
            this.showSnackbar("Total distance synchronized successfully!", "success");

        }
        })
        .catch(() => {
        this.loadningScreen = false;
        });
    },

    getOutletDeteails(firstId, lastId) {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      axios
        .post(
          `api/getOutletDetails`,
          {
            userId: userId,
            firstId: firstId,
            lastId: lastId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.firstOutlet = response.data.first;
          this.secondOutlet = response.data.first;
        })
        .catch((error) => {
          console.error("Error fetching Agents:", error);
        });
    },

    // mapView(item) {
    //     console.log('itemssssssssssssssss', item);
    //     this.mapViewDialog = true;
    //     this.startLocation = item.fistAddress;
    //     this.endLocation = item.lastAddress;
    //     this.agentName = item.agentName;
    //     this.visitedDate = item.date;  
    //     this.startTime = item.statTime;
    //     this.endTime = item.endTime;
    //     this.agentImage = item.agentImage;

    //     if (item.OverRollTrackingDetails.length > 0) {
    //         // Map pathCoordinates using correct property names
    //         this.pathCoordinates = item.OverRollTrackingDetails
    //             .map(point => {
    //                 const lat = parseFloat(point.lat);
    //                 const lng = parseFloat(point.lng);

    //                 // Ensure lat & lng are valid numbers before adding to array
    //                 if (!isNaN(lat) && !isNaN(lng)) {
    //                     return { lat, lng };
    //                 } else {
    //                     console.warn(`Invalid coordinate found: lat=${point.lat}, lng=${point.lng}`);
    //                     return null; // Return null for invalid values
    //                 }
    //             })
    //             .filter(coord => coord !== null); // Remove null values

    //         console.log('trackingdata', this.pathCoordinates);

    //         if (this.pathCoordinates.length > 0) {
    //             // Update the map center to the first valid point in the history
    //             this.mapCenter = {
    //                 lat: this.pathCoordinates[0].lat,
    //                 lng: this.pathCoordinates[0].lng
    //             };

    //             // Set start and end points
    //             this.endPoint = this.pathCoordinates[0];
    //             this.startPoint = this.pathCoordinates[this.pathCoordinates.length - 1];

    //             // Calculate total distance
    //             // this.totalDistance = this.calculateTotalDistance(this.pathCoordinates);
    //              // Calculate total distance and format it
    //         const distance = this.calculateTotalDistance(this.pathCoordinates);
    //         this.totalDistance = distance < 1
    //             ? `${(distance * 1000).toFixed(0)} m`
    //             : `${distance.toFixed(2)} Km`;
    //         } else {
    //             console.warn('No valid coordinates found in tracking data.');
    //         }
    //     }
    // },

    // With SmapTORoad
    //     async mapView(item) {
    //     console.log('itemssssssssssssssss', item);
    //     this.mapViewDialog = true;
    //     this.startLocation = item.fistAddress;
    //     this.endLocation = item.lastAddress;
    //     this.agentName = item.agentName;
    //     this.visitedDate = item.date;
    //     this.startTime = item.statTime;
    //     this.endTime = item.endTime;
    //     this.agentImage = item.agentImage;

    //     if (item.OverRollTrackingDetails.length > 0) {
    //         // Snap the coordinates before showing
    //         const snappedCoords = await this.snapToRoadsFromTracking(item.OverRollTrackingDetails);

    //         if (snappedCoords.length > 0) {
    //             this.pathCoordinates = snappedCoords;

    //             console.log('Snapped tracking data', this.pathCoordinates);

    //             // Set map center and start/end points
    //             this.mapCenter = {
    //                 lat: this.pathCoordinates[0].lat,
    //                 lng: this.pathCoordinates[0].lng
    //             };

    //             this.startPoint = this.pathCoordinates[0];
    //             this.endPoint = this.pathCoordinates[this.pathCoordinates.length - 1];

    //             // Calculate total distance
    //             const distance = this.calculateTotalDistance(this.pathCoordinates);
    //             this.totalDistance = distance < 1
    //                 ? `${(distance * 1000).toFixed(0)} m`
    //                 : `${distance.toFixed(2)} Km`;
    //         } else {
    //             console.warn('No valid snapped coordinates found.');
    //         }
    //     }
    // },

    // WIthOut snapToRoads
    async mapView(item) {
    // Assign initial values from item
    console.log('itemssssssssssssssss', item);
    this.startLocation = item.start_address;
    this.endLocation = item.end_address;
    this.totalDistance = item.total_distance;
    this.officialDistance = item.official_distance;
    this.personalDistance = item.personal_distance;
    this.agentName = item.user.name;
    this.selectedAgentID = item.user.id;
    this.visitedDate = item.date;
    this.agentImage = item.agentImage;
    this.startTime = item.start_time;
    this.endTime = item.end_time;

    // Initialize placeholders
    this.personalDistanceManualEntry = '0.000';
    this.officialDistanceManualEntry = '0.000';

    // Token/user check
    this.loadningScreen = true;
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('token');

    if (!userId || !this.selectedAgentID || !this.visitedDate || !token) {
        this.loadningScreen = false;
        this.showSnackbar("Missing required data", "error");
        return;
    }

    try {
        const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}api/getPresanalManuallyEntry`,
        {
            userID: userId,
            agentId: this.selectedAgentID,
            date: this.visitedDate
        },
        {
            headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
            }
        }
        );

        if (response.data.http_status === 'success') {
        const manualEntry = parseFloat(response.data.data?.personal_km || 0);
        const total = parseFloat(this.totalDistance || 0);

        // If there is a manual entry, calculate derived official distance
        if (manualEntry > 0) {
        const derivedOfficial = total - manualEntry;
        this.officialDistanceManualEntry = derivedOfficial.toFixed(3);
        } else {
        this.officialDistanceManualEntry = total;
        }

        this.personalDistanceManualEntry = manualEntry.toFixed(3);
        this.mapViewDialog = true;
        } else {
        this.showSnackbar(response.data.message || "Something went wrong", "error");
        }
    } catch (error) {
        this.showSnackbar("Failed to load data", "error");
    } finally {
        this.loadningScreen = false;
    }
  },


    async snapToRoadsFromTracking(details) {
      const apiKey = "";
      const coords = details
        .map((point) => {
          const lat = parseFloat(point.lat);
          const lng = parseFloat(point.lng);
          return !isNaN(lat) && !isNaN(lng) ? `${lat},${lng}` : null;
        })
        .filter((coord) => coord !== null);

      if (coords.length === 0) return [];

      // Handle batching if more than 100 points
      const batchSize = 100;
      const snappedAll = [];

      for (let i = 0; i < coords.length; i += batchSize) {
        const batchPath = coords.slice(i, i + batchSize).join("|");
        const url = `https://roads.googleapis.com/v1/snapToRoads?path=${batchPath}&interpolate=true&key=${apiKey}`;

        try {
          const response = await fetch(url);
          const data = await response.json();

          if (data.snappedPoints) {
            const batchSnapped = data.snappedPoints.map((p) => ({
              lat: p.location.latitude,
              lng: p.location.longitude,
            }));
            snappedAll.push(...batchSnapped);
          }
        } catch (error) {
          console.error("Snap to Roads API error:", error);
        }
      }

      return snappedAll;
    },

    // Function to calculate total distance between the path coordinates using Haversine formula
    calculateTotalDistance(pathCoordinates) {
      // Function to convert degrees to radians
      const toRadians = (deg) => deg * (Math.PI / 180);

      // Haversine formula
      const haversineDistance = (lat1, lng1, lat2, lng2) => {
        const R = 6371; // Radius of the Earth in kilometers
        const dLat = toRadians(lat2 - lat1);
        const dLng = toRadians(lng2 - lng1);

        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(toRadians(lat1)) *
            Math.cos(toRadians(lat2)) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance;
      };

      let totalDistance = 0;
      // Loop through pathCoordinates and sum the distance between consecutive points
      for (let i = 0; i < pathCoordinates.length - 1; i++) {
        const point1 = pathCoordinates[i];
        const point2 = pathCoordinates[i + 1];

        totalDistance += haversineDistance(
          point1.lat,
          point1.lng,
          point2.lat,
          point2.lng
        );
      }
      return totalDistance;
    },

    closeD() {
      this.mapViewDialog = false;
    },

    confirmDelete(item) {
      this.deleteAgentId = item.agentId;
      this.deleteDate = item.date;
      this.deleteDialog = true;
    },

    deleteItem() {
      this.loadningScreen = true;
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      axios
        .post(
          `api/deletOverRollTrackingDetails`,
          {
            userId: userId,
            agentId: this.deleteAgentId,
            date: this.deleteDate,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.deleteDialog = false;
          this.getAllTotalDistanceTracking(this.page);
          console.log("deleted", response.data);
          this.loadningScreen = false;
          this.showSnackbar("History delete successfully!", "success");
        })
        .catch((error) => {
          this.loadningScreen = false;
          console.error("Error fetching Agents:", error);
        });
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    fetchAllAgents() {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/agentUser`,
          { userId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.agentDataOptions = response.data.data.map((agent) => ({
            id: agent.id,
            name: agent.name,
            regNum: agent.registration_num,
            type: agent.type || "default", // Assuming there's a type field
          }));

          // Extract unique officer types for filter
          const types = [
            ...new Set(
              response.data.data.map((agent) => agent.type || "default")
            ),
          ];
          this.agentTypeOptions = types.map((type) => ({
            name: type,
            value: type,
          }));

          
        })
        .catch((error) => {
          console.error("Error fetching agents:", error);
        });
    },
  },
};
</script>


<style>
@import "../../styles/tracking_management/overall_tracking_history.scss";
</style>